import { render, staticRenderFns } from "./gsc.vue?vue&type=template&id=34b35ecc&scoped=true"
import script from "./gsc.vue?vue&type=script&lang=js"
export * from "./gsc.vue?vue&type=script&lang=js"
import style0 from "./gsc.vue?vue&type=style&index=0&id=34b35ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34b35ecc",
  null
  
)

export default component.exports